import React, { useState, useEffect } from "react";
import "./NapovedaSt.css"
import { MdQuestionMark } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Modal from '@mui/material/Modal';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: '#EEEDEB',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const NapovedaSt = () => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
        <Tooltip title="Nápověda.." arrow>
            <button id='btnHelp' onClick={handleOpen}>
                <MdQuestionMark />
            </button>
        </Tooltip>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style} className="modalPr">
                <IoClose className="btnCloseMod" onClick={handleClose}/> 
                <h2>
                    Nápověda - Statistiky
                </h2>
                    <div className="helpOdstavec">
                        <b>S1 - Přehled Archivních Rezervací:</b> 
                        <br></br>
                            * slouží k zobrazení všech archivních rezervací, které již byly ukončeny 
                        <br></br>
                            vstupní parametry:
                            <ul>
                                <li>Platnost OD - DO (období kdy byla rezervace platná)</li>
                            </ul>
                    </div>
                    <div className="helpOdstavec">
                        <b>S2 - Přehled Dokladů:</b> 
                        <br></br>
                            * slouží k zobrazení všech dokladů, tlačítkem tisk je možno si jednotlivé doklady zobrazit v novém okně a následně vytisknout
                        <br></br>
                            vstupní parametry:
                            <ul>
                                <li>Platnost OD - DO (období kdy byla rezervace platná)</li>
                            </ul>
                    </div>            
                
            </Box>
        </Modal>
        </>
    )
}

export { NapovedaSt };